import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué parte del cerebro estimula SAINT®?",
    answer:
      "SAINT® utiliza una fMRI para identificar de forma individualizada el circuito de la corteza prefrontal dorsolateral asociado con la depresión en cada persona. La orientación es personalizada, no la misma para todos.",
  },
];

export const esBrainTarget = makeEsArticle({
  slug: "what-part-of-brain-does-saint-target",
  title: "¿Qué parte del cerebro estimula SAINT®?",
  description:
    "SAINT® utiliza fMRI para localizar de forma individualizada el circuito de la corteza prefrontal dorsolateral asociado con la depresión en cada paciente.",
  h1: "¿Qué parte del cerebro estimula SAINT®?",
  breadcrumbLabel: "Objetivo cerebral de SAINT®",
  shortAnswer:
    "SAINT® utiliza una resonancia magnética funcional (fMRI) para identificar de forma individualizada el circuito de la corteza prefrontal dorsolateral asociado con la depresión en cada persona. A diferencia de la TMS convencional, que usa mediciones generales del cuero cabelludo, SAINT® personaliza el objetivo de estimulación para cada paciente. SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
  keyTakeaways: [
    "SAINT® estimula la corteza prefrontal dorsolateral.",
    "El objetivo se identifica con fMRI de forma individualizada.",
    "La orientación es personalizada, no la misma para todos.",
    "La TMS convencional usa mediciones generales del cuero cabelludo.",
    "SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos.",
  ],
  sections: [
    {
      heading: "Orientación individualizada por fMRI",
      paragraphs: [
        "Antes del tratamiento, SAINT® realiza una fMRI para mapear las redes cerebrales relacionadas con la depresión. El software identifica el punto exacto del circuito de la corteza prefrontal dorsolateral asociado con la depresión en cada persona, y la bobina se coloca en ese objetivo durante cada sesión mediante neuronavegación.",
      ],
    },
    {
      heading: "Diferencia con la TMS convencional",
      paragraphs: [
        "La TMS convencional ubica el objetivo con mediciones estandarizadas del cuero cabelludo, aplicando el mismo punto para todos. SAINT® personaliza el objetivo a la red cerebral de cada paciente, lo que distingue su enfoque.",
      ],
    },
  ],
  faqs,
  sources: [
    {
      citation:
        "Cole EJ, et al. Stanford Accelerated Intelligent Neuromodulation Therapy for Treatment-Resistant Depression. Am J Psychiatry. 2020;177(8):716-726.",
      url: "https://doi.org/10.1176/appi.ajp.2019.19070720",
    },
  ],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
